import { Tag } from 'antd';
import { useTranslation } from 'react-i18next';
import NoValue from './NoValue';
import { errorCodeTagStyle } from './vinExtractionStyles';
import { NO_CHECK_DIGIT_TAG } from '../../utils/vinExtraction';

/**
 * Mono tags for an attempt's error codes (`errorTags`), or "—" when there are none. Errors are red; `no_check_digit`
 * is grey, with a hint saying why it is not an error.
 */
const ErrorCodeTags = ({ tags }) => {
    const { t } = useTranslation('vinExtraction');

    if (!tags.length) return <NoValue label={t('cars.noErrors')} />;

    return tags.map(code => {
        const notice = code === NO_CHECK_DIGIT_TAG;
        return (
            <Tag
                key={code}
                color={notice ? 'default' : 'error'}
                bordered={false}
                style={errorCodeTagStyle}
                title={notice ? t('cars.noCheckDigitHint') : undefined}
            >
                {code}
            </Tag>
        );
    });
};

export default ErrorCodeTags;
